

import React  from 'react';
import {GridWrap, ListWrap, Elements} from "./helpers" 

export const TestimonialTwo = function({data, index, widgetType, mode, device}) { 
    // console.log("TestimonialTwo", data)  
    let listitem = "" 
    if(data.elements.testimonials){ 
         if(data.elements.testimonials.items){   
            listitem = data.elements.testimonials.items.map(function(v, i){    
                return <GridWrap data={v} key={'key-' + v.viewId + i} id="testimonials" mode={mode} device={device}>
                    <Elements row={v.heading} id={"heading"} device={device} /> 
                    <div className={`d-flex w-100 align-items-center justify-content-${data.elements.testimonials.properties.textAlignment}`}>   
                        <Elements row={v.banner} id={"banner"} classType="testimonial-thumb" device={device} mode={mode} />   
                        <Elements row={v.summary} id={"summary"} device={device} mode={mode} />
                    </div>   
                </GridWrap>
            }) 
        } 
        listitem = <ListWrap data={data.elements.testimonials} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

return <div className="container-fluid p-0 position-relative"> 
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />  
            </div>
        </div>
        {listitem} 
    </div>
}

export const TestimonialOne = function({data, index, widgetType, mode, device}) { 
    let listitem = "" 
    if(data.elements.testimonials){ 
         if(data.elements.testimonials.items){   
            listitem = data.elements.testimonials.items.map(function(v, i){    
                return <GridWrap data={v} key={'key-' + v.viewId + i} id="testimonials" mode={mode} device={device}>
                    <div className="d-inline-block w-100">
                        <Elements row={v.banner} id={"banner"} classType="testimonial-thumb" device={device} mode={mode} />  
                        <div className="overflow-hidden p-1"> 
                            <Elements row={v.heading} id={"heading"} device={device} mode={mode} />  
                            <Elements row={v.summary} id={"summary"} device={device} mode={mode} /> 
                        </div> 
                    </div> 
                </GridWrap>  
            }) 
        }
        
    listitem = <ListWrap data={data.elements.testimonials} mode={mode} device={device} index={index}>
        {listitem}
    </ListWrap>
    }

return <div className="container-fluid p-0 position-relative"> 
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />  
            </div>
        </div>
        {listitem} 
    </div>
}





export const TestimonialThree = function({data, index, widgetType, mode, device}) {
    // console.log("TestimonialThree", data) 
    let listitem = "" 
    if(data.elements.testimonials){ 
         if(data.elements.testimonials.items){   
            listitem = data.elements.testimonials.items.map(function(v, i){    
                return <GridWrap swiper={data.elements.testimonials.properties.isSwiper} data={v} key={'key-' + v.viewId + i} className={'h-100'} id="testimonials" mode={mode} device={device}>
                    <Elements row={v.banner} id={"banner"} device={device} mode={mode} />  
                    <div className="overflow-hidden p-1">   
                        <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                        <Elements row={v.summary} id={"summary"} device={device} mode={mode} /> 
                    </div>   
                </GridWrap>  
            }) 
        }
        
    listitem = <ListWrap data={data.elements.testimonials} mode={mode} device={device} index={index}>
        {listitem}
    </ListWrap>
    }

return  <div className="container-fluid p-0 position-relative"> 
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />  
            </div>
        </div>
        {listitem} 
    </div>
}



 